import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/login/logo.png'


const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "right-side" }
const _hoisted_5 = { class: "message-box-trigger" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]

import {computed, ref, inject, watch, onMounted, nextTick} from "vue";
import {Message} from "@arco-design/web-vue";
import {useDark, useToggle} from "@vueuse/core";
import {useAppStore, useUserStore} from "@/store";
import {useRouter} from "vue-router";
import useUser from "@/hooks/user";
import {setSessionLoginSchooId, quitSessionLoginSchooId} from "@/api/user";
import {setToken} from "@/utils/auth";
import useLoading from "@/hooks/loading";
import FileBox from './file-box.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const appStore = useAppStore();
const userStore = useUserStore();
const router = useRouter();
const schoolName = ref("");
const isReadonly = ref(true);
const select = ref<HTMLDivElement>();
let showName = ref(false);
const {logout} = useUser();
const logoutVisible = ref(false);
const {loading, setLoading} = useLoading(false);
const avatar = computed(() => {
  return userStore.avatar || "";
});
const logo = require("@/assets/logo.jpg");
const gohome = () => {
  router.replace({name: "home"});
};
const userName = computed(() => {
  return userStore.nickName;
});
const isAdmin = computed(() => {
  return userStore.admin;
});
const barrackId = computed(() => {
  return userStore.barrackId;
});
const barrackName = computed(() => {
  return userStore.barrackName;
});
const loginBarrackId = computed(() => {
  return userStore.loginBarrackId;
});
const project = computed(() => {
  return userStore.project;
});
const theme = computed(() => {
  return appStore.theme;
});
const isDark = useDark({
  selector: "body",
  attribute: "arco-theme",
  valueDark: "dark",
  valueLight: "light",
  storageKey: "arco-theme",
  onChanged(dark: boolean) {
    // overridded default behavior
    appStore.toggleTheme(dark);
  },
});
const toggleTheme = useToggle(isDark);
const setVisible = () => {
  appStore.updateSettings({globalSettings: true});
};
const enterUnit = () => {
};
const refBtn = ref();
const triggerBtn = ref();
const setPopoverVisible = () => {
  const event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  refBtn.value.dispatchEvent(event);
};
const refreshAll = () => {
  appStore.setHasRoutes(false);
  setLoading(false);
  window.location.href = window.location.origin + "/web/";
};
const selectUnit = (val) => {
  setLoading(true);
  setSessionLoginSchooId(val)
      .then((response) => {
        userStore.setLoginBarrackId(val);
        let barrackName = project.value.filter((i) => i.id == val)[0].barrackName;
        userStore.setBarrackName(barrackName);
        setToken(response.token);
        setTimeout(() => {
          refreshAll();
        });
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Message.error("进入军区失败，请联系客服，错误原因：" + error);
      });
};

const exitUnit = () => {
  setLoading(true);
  quitSessionLoginSchooId()
      .then((response) => {
        userStore.setLoginBarrackId("");
        userStore.setBarrackName("");
        setToken(response.token);
        setTimeout(() => {
          refreshAll();
        });
      })
      .catch((error) => {
        setLoading(false);
        Message.error("退出军区失败，请联系客服，错误原因：" + error);
      });
};
const handleLogout = () => {
  logoutVisible.value = true;
};
const logoutOk = () => {
  logoutVisible.value = false;
  logout().then((res) => {
    appStore.setHasRoutes(false);
    router.replace({name: "login"});
  });
};
const cancel = () => {
  logoutVisible.value = false;
};
const setDropDownVisible = () => {
  const event = new MouseEvent("click", {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  triggerBtn.value.dispatchEvent(event);
};
const userCenter = () => {
  router.push("/userCenter");
};
const switchRoles = async () => {
  const res = await userStore.switchRoles();
  Message.success(res as string);
};
const toggleDrawerMenu = inject("toggleDrawerMenu");

return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_icon_file = _resolveComponent("icon-file")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_IconUser = _resolveComponent("IconUser")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_icon_user = _resolveComponent("icon-user")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_icon_export = _resolveComponent("icon-export")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_typography_title, {
            class: "title",
            style: { margin: 0, fontSize: '18px' },
            heading: 5
          }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: _imports_0,
                style: {"height":"24px","width":"24px","margin-right":"10px"}
              }, null, -1)),
              _cache[2] || (_cache[2] = _createTextVNode(" 军人体能训练管理考核系统 ")),
              (barrackName.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "| " + _toDisplayString(barrackName.value), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_button, {
            class: "nav-btn",
            type: "primary",
            onClick: setPopoverVisible
          }, {
            default: _withCtx(() => [
              _createVNode(_component_icon_file),
              _cache[3] || (_cache[3] = _createTextVNode(" 文件管理助手 "))
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_popover, {
          trigger: "click",
          "arrow-style": { display: 'none' },
          "content-style": { padding: 0, minWidth: '400px' },
          "content-class": "message-popover"
        }, {
          content: _withCtx(() => [
            _createVNode(FileBox)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              ref_key: "refBtn",
              ref: refBtn,
              class: "ref-btn"
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      (!barrackId.value && !loginBarrackId.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createVNode(_component_a_dropdown, null, {
              content: _withCtx(() => [
                _createVNode(_component_a_select, {
                  style: { width: '220px' },
                  placeholder: "搜索营区",
                  "allow-search": "",
                  bordered: false,
                  "default-popup-visible": true,
                  "allow-clear": "",
                  onChange: selectUnit,
                  popupVisible: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.value, (item) => {
                      return (_openBlock(), _createBlock(_component_a_option, {
                        key: item.id,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.barrackName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  class: "nav-btn",
                  type: "primary",
                  onClick: enterUnit
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" 进入营区")
                  ])),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createElementVNode("input", {
                  type: "text",
                  placeholder: "请输账户",
                  class: "fake-input",
                  style: {"display":"none"}
                }, null, -1)),
                _cache[6] || (_cache[6] = _createElementVNode("input", {
                  type: "password",
                  placeholder: "请输密码",
                  class: "fake-input",
                  style: {"display":"none"}
                }, null, -1))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!barrackId.value && loginBarrackId.value)
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _createVNode(_component_a_button, {
              class: "nav-btn",
              type: "primary",
              onClick: exitUnit
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" 退出营区")
              ])),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createVNode(_component_a_dropdown, { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(_component_a_doption, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, { onClick: userCenter }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_user),
                    _cache[8] || (_cache[8] = _createElementVNode("span", null, " 个人中心 ", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_doption, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, { onClick: handleLogout }, {
                  default: _withCtx(() => [
                    _createVNode(_component_icon_export),
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, " 退出 ", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_avatar, {
              size: 32,
              style: { marginRight: '8px', cursor: 'pointer', verticalAlign: 'middle', backgroundColor: '#168cff' }
            }, {
              default: _withCtx(() => [
                (avatar.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      alt: "avatar",
                      src: avatar.value
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createBlock(_component_IconUser, { key: 1 }))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(userName.value) + " ", 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_a_modal, {
      simple: true,
      visible: logoutVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((logoutVisible).value = $event)),
      onCancel: cancel,
      onOk: logoutOk
    }, {
      title: _withCtx(() => _cache[10] || (_cache[10] = [
        _createTextVNode(" 退出")
      ])),
      default: _withCtx(() => [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-c" }, "确认退出系统吗？", -1))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})